import { cubicFromArc as _arc, cubicFromLine as _line, cubicFromQuadratic as _quad, } from "@thi.ng/geom-splines";
import { Cubic } from "../api/cubic";
import { copyAttribs } from "../internal/copy-attribs";
import { pclike } from "../internal/pclike";
export function cubic(...args) {
    return pclike(Cubic, args);
}
export const cubicFromArc = (arc) => _arc(arc.pos, arc.r, arc.axis, arc.start, arc.end).map((c) => new Cubic(c, copyAttribs(arc)));
export const cubicFromLine = (a, b, attribs) => new Cubic(_line(a, b), attribs);
export const cubicFromQuadratic = (a, b, c, attribs) => new Cubic(_quad(a, b, c), attribs);
